import { useCallback, useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { cardApi } from "@/components/admin/TrainingskartenTab";

export const LegacyOrders = ({ adminToken, onConverted }) => {
  const [orders, setOrders] = useState([]);

  const load = useCallback(async () => {
    try { setOrders((await cardApi(adminToken, "/legacy-orders")).orders); } catch { setOrders([]); }
  }, [adminToken]);
  useEffect(() => { load(); }, [load]);

  const convert = async (o) => {
    if (!window.confirm(`Bestellung ${o.package_id} als Trainingskarte übernehmen? Es wird keine Rechnung und keine E-Mail erzeugt, die Karte bleibt „Nicht bezahlt“.`)) return;
    try {
      const d = await cardApi(adminToken, `/legacy-orders/${o.package_id}/convert`, "POST");
      toast.success(`Übernommen als ${d.card.card_id}`);
      await load(); onConverted();
    } catch (e) { toast.error(e.message); }
  };

  if (orders.length === 0) return null;
  return (
    <div className="bg-yellow-500/10 border border-yellow-500/30 rounded-lg p-4 space-y-3" data-testid="legacy-orders">
      <p className="font-semibold flex items-center gap-2 text-yellow-500"><AlertTriangle className="w-4 h-4" /> Offene Kartenbestellungen aus dem alten Paketsystem ({orders.length})</p>
      <p className="text-xs text-[#A1A1AA]">Diese Bestellungen wurden vor der Freischaltung der Trainingskarten gespeichert. Übernimm sie hier, um sie wie neue Karten zu verwalten.</p>
      {orders.map((o) => (
        <div key={o.package_id} className="flex flex-wrap items-center justify-between gap-2 bg-[#0A0A0A] rounded p-3 text-sm" data-testid={`legacy-order-${o.package_id}`}>
          <span>
            <span className="font-mono text-[#c1ff72]">{o.package_id}</span> · {o.package_name} · {o.training_name} · {o.total_price} €
            <span className="block text-xs text-[#71717A]">{o.customer_name} · {o.customer_email} · {new Date(o.created_at).toLocaleString("de-DE", { timeZone: "Europe/Berlin" })}</span>
          </span>
          <Button size="sm" onClick={() => convert(o)} className="bg-[#c1ff72] text-[#0A0A0A] hover:bg-[#a8e65c]" data-testid={`btn-convert-${o.package_id}`}>
            Als Trainingskarte übernehmen
          </Button>
        </div>
      ))}
    </div>
  );
};
